import React from 'react';

export default function DownArrow(props) {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x="0.666992" width="16" height="16" rx="8" fill={props.rectcolor || "#FEE4E2"} />
            <path
                d="M8.66699 4.5V11.5M8.66699 11.5L5.16699 8M8.66699 11.5L12.167 8"
                stroke={props.color || "#D92D20"}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
